import React from 'react';
import { returnLocalisedPath } from '../../../utils/globals';

export const ALL_LOCALES = [
  'en-eu',
  'en-us',
  'en-ca',
  'en-gb',
  'it-it',
  'fr-fr',
  'nl-nl',
  'de-de',
  'es-es',
  'pt-pt',
  'fr-ca',
];

export const returnHrefLangLinks = (siteUrl, allLocalSlugs) => {
  const links = [];
  // X default href land
  links.push(
    <link
      rel='alternate'
      href={`${siteUrl}/${
        allLocalSlugs.find((s) => s.node_locale.toLowerCase() === 'en')?.slug
          ?.url || ''
      }`}
      hrefLang='x-default'
    />
  );

  // locale
  ALL_LOCALES.forEach((l) => {
    if (l.includes('us')) {
      links.push(
        <link
          rel='alternate'
          href={`${siteUrl}/us${returnLocalisedPath(
            l,
            allLocalSlugs.find((s) => s.node_locale.toLowerCase() === l)?.slug
              ?.url || ''
          )}`}
          hrefLang={l}
        />
      );
    } else if (l.includes('gb')) {
      links.push(
        <link
          rel='alternate'
          href={`${siteUrl}/gb${returnLocalisedPath(
            l,
            allLocalSlugs.find((s) => s.node_locale.toLowerCase() === 'en')
              ?.slug?.url || ''
          )}`}
          hrefLang={l}
        />
      );
    } else if (l.includes('fr-ca')) {
      links.push(
        <link
          rel='alternate'
          href={`${siteUrl}/ca${returnLocalisedPath(
            l,
            allLocalSlugs.find((s) => s.node_locale.toLowerCase() === 'fr-fr')
              ?.slug?.url || ''
          )}`}
          hrefLang={l}
        />
      );
    } else if (l.includes('ca')) {
      links.push(
        <link
          rel='alternate'
          href={`${siteUrl}/ca${returnLocalisedPath(
            l,
            allLocalSlugs.find((s) => s.node_locale.toLowerCase() === l)?.slug
              ?.url || ''
          )}`}
          hrefLang={l}
        />
      );
    } else if (l.includes('en')) {
      links.push(
        <link
          rel='alternate'
          href={`${siteUrl}/eu${returnLocalisedPath(
            l,
            allLocalSlugs.find((s) => s.node_locale.toLowerCase() === 'en')
              ?.slug?.url || ''
          )}`}
          hrefLang={l}
        />
      );
    } else {
      links.push(
        <link
          rel='alternate'
          href={`${siteUrl}/eu${returnLocalisedPath(
            l,
            allLocalSlugs.find((s) => s.node_locale.toLowerCase() === l)?.slug
              ?.url || ''
          )}`}
          hrefLang={l}
        />
      );
    }
  });
  return links;
};
